module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-row', [_c('b-navbar-nav'), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', {
    staticClass: "page-title mb-2"
  }, [_c('b', [_vm._v(_vm._s(_vm.$route.name))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Assignment"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  }), _vm._v(" "), _c('b-input-group-append', {
    staticClass: "mr-1"
  }, [_c('b-button', {
    attrs: {
      "disabled": !_vm.Filter.commonFilter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1",
    class: ' pull-right mb-1' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.userFilter ||
        _vm.Filter.lomInvNoFilter ||
        _vm.Filter.lom_ledger_nameFilter ||
        _vm.Filter.lom_doc_typeFilter ||
        _vm.Filter.lom_gst_noFilter ||
        _vm.Filter.lom_pan_noFilter ||
        _vm.Filter.lom_comp_nameFilter ||
        _vm.Filter.lom_ref_typeFilter ||
        _vm.Filter.lom_reference_noFilter ||
        _vm.Filter.lom_doc_dateFilter ||
        _vm.Filter.isActiveFilter ||
        _vm.Filter.commonFilter ||
        _vm.Filter.clientIdFilter ||
        _vm.Filter.createdAtRange.startDate ||
        _vm.Filter.createdAtRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.userFilter ||
    _vm.Filter.lomInvNoFilter ||
    _vm.Filter.lom_ledger_nameFilter ||
    _vm.Filter.lom_doc_typeFilter ||
    _vm.Filter.lom_gst_noFilter ||
    _vm.Filter.lom_pan_noFilter ||
    _vm.Filter.lom_comp_nameFilter ||
    _vm.Filter.lom_ref_typeFilter ||
    _vm.Filter.lom_reference_noFilter ||
    _vm.Filter.lom_doc_dateFilter ||
    _vm.Filter.isActiveFilter ||
    _vm.Filter.commonFilter ||
    _vm.Filter.clientIdFilter ||
    _vm.Filter.createdAtRange.startDate ||
    _vm.Filter.createdAtRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.OutstandingList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName !== 'Export As Excel',
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('checkJobPendency', 'Export As Excel')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.ExcelBtnName) + "\n                        "), (_vm.ExcelBtnName !== 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('userId')) ? _c('userBasedClient', {
    attrs: {
      "PMC_title": 'User Summary - ' + _vm.$sessionsStorage.get('employeeName'),
      "PMC_USERID": _vm.Filter.userFilter,
      "PMC_USERNAME": _vm.$sessionsStorage.get('nameUser'),
      "PMC_USERDESIG": _vm.$sessionsStorage.get('designation'),
      "PMC_BranchClientPre": _vm.$sessionsStorage.get('branchclientPre'),
      "PMC_TransportTypePre": _vm.$sessionsStorage.get('transportTypePre'),
      "PMC_UserEmpName": _vm.$sessionsStorage.get('employeeName'),
      "PMC_UserEmpCode": _vm.$sessionsStorage.get('employeeCode')
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('h5', [(!_vm.isLoading) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": function($event) {
        _vm.getOutstandingList('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdAtRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdAtRange", $$v)
      },
      expression: "Filter.createdAtRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("User")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "addedUserFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.userFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "userFilter", $$v)
      },
      expression: "Filter.userFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "lomInvNoFilter"
    }
  }, [_vm._v("Inv No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "lomInvNoFilter",
      "type": "text"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.lomInvNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "lomInvNoFilter", $$v)
      },
      expression: "Filter.lomInvNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "lom_ledger_nameFilter"
    }
  }, [_vm._v("Ledger Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "lom_ledger_nameFilter",
      "type": "text"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.lom_ledger_nameFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "lom_ledger_nameFilter", $$v)
      },
      expression: "Filter.lom_ledger_nameFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "lom_doc_typeFilter"
    }
  }, [_vm._v("Doc Type")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "lom_doc_typeFilter",
      "type": "text"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.lom_doc_typeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "lom_doc_typeFilter", $$v)
      },
      expression: "Filter.lom_doc_typeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "lom_gst_noFilter"
    }
  }, [_vm._v("GST No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "lom_gst_noFilter",
      "type": "text"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.lom_gst_noFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "lom_gst_noFilter", $$v)
      },
      expression: "Filter.lom_gst_noFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "lom_pan_noFilter"
    }
  }, [_vm._v("PAN No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "lom_pan_noFilter",
      "type": "text"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.lom_pan_noFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "lom_pan_noFilter", $$v)
      },
      expression: "Filter.lom_pan_noFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "lom_comp_nameFilter"
    }
  }, [_vm._v("Company Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "lom_comp_nameFilter",
      "type": "text"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.lom_comp_nameFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "lom_comp_nameFilter", $$v)
      },
      expression: "Filter.lom_comp_nameFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "lom_ref_typeFilter"
    }
  }, [_vm._v("Ref. Type")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "lom_ref_typeFilter",
      "type": "text"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.lom_ref_typeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "lom_ref_typeFilter", $$v)
      },
      expression: "Filter.lom_ref_typeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "lom_reference_noFilter"
    }
  }, [_vm._v("Ref. No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "lom_reference_noFilter",
      "type": "text"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.lom_reference_noFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "lom_reference_noFilter", $$v)
      },
      expression: "Filter.lom_reference_noFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "lom_doc_dateFilter"
    }
  }, [_vm._v("Doc Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "lom_doc_dateFilter",
      "type": "date"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.lom_doc_dateFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "lom_doc_dateFilter", $$v)
      },
      expression: "Filter.lom_doc_dateFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "isActiveFilter"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.listStatus,
      "id": "isActiveFilter",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.isActiveFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "isActiveFilter", $$v)
      },
      expression: "Filter.isActiveFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "isActiveFilter"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientfilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.clientIdFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientIdFilter", $$v)
      },
      expression: "Filter.clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row "
  }, [_c('b-table', {
    staticClass: "table-background position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "fields": _vm.columnMain,
      "items": _vm.OutstandingList,
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter
    },
    on: {
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "lom_is_active",
      fn: function(row10) {
        return [_c('div', {
          attrs: {
            "id": 'row' + row10.item.booking_id
          }
        }, [(
          _vm.$sessionsStorage.get('designation') == 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row10.item.booking_id,
            "name": "approval",
            "value": row10.item.lom_is_active == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateLedger(row10.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row10.item.lom_is_active == 1 ? 'success' : 'danger'
          }
        }, [_vm._v("\n                                        " + _vm._s(row10.item.lom_is_active == 1 ? 'Active' : 'In-ACtive'))])], 1)]) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-556af95c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ledgerOutstanding/outstanding.vue
// module id = 2642
// module chunks = 0